<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('iamee.create_organization') }}</div>
    <div slot="body">
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        v-bind="formItemLayout">
        <a-form-model-item :label="$t('table.title.name')" prop="name">
          <a-input v-model="form.name" :placeholder="$t('common.tips.input',[$t('table.title.name')])" />
        </a-form-model-item>
        <a-form-model-item :label="$t('iamee.organization_type')" prop="type">
          <a-select
            v-model="form.type"
            :select-props="{placeholder: $t('common.tips.select', [$t('iamee.organization_type')])}">
            <a-select-option v-for="(item, index) in orgTypeOpts" :key="index" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('table.title.desc')" prop="description">
          <a-input v-model="form.description" :placeholder="$t('common.tips.input',[$t('table.title.desc')])" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { validateModelForm } from '@/utils/validate'

export default {
  name: 'OrganizationCreateDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        name: '',
        description: '',
        type: 'project',
      },
      rules: {
        type: { required: true, message: this.$t('common.tips.select', [this.$t('iamee.organization_type')]) },
        name: { required: true, message: this.$t('common.tips.input', [this.$t('table.title.name')]) },
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      orgTypeOpts: [
        { id: 'project', name: this.$t('dictionary.project') },
        { id: 'domain', name: this.$t('dictionary.domain') },
      ],
    }
  },
  destroyed () {
    this.manager = null
  },
  created () {
    this.manager = new this.$Manager('organizations', 'v1')
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        await validateModelForm(this.$refs.form)
        await this.manager.create({
          data: {
            ...this.form,
            key: [],
          },
        })
        this.loading = false
        this.params.success()
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
